/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_agreement_requestGetAgreement } from '../models/api_agreement_requestGetAgreement';
import type { api_agreement_requestGetStaffDistribution } from '../models/api_agreement_requestGetStaffDistribution';
import type { api_agreement_responseGetAgreement } from '../models/api_agreement_responseGetAgreement';
import type { api_agreement_responseGetStaffDistribution } from '../models/api_agreement_responseGetStaffDistribution';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AgreementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get ibow agreement
     * Get Agreement
     * @returns api_agreement_responseGetAgreement responseGetAgreement
     * @throws ApiError
     */
    public postAgreementGet({
        body,
    }: {
        /**
         * requestGetAgreement
         */
        body: api_agreement_requestGetAgreement,
    }): CancelablePromise<api_agreement_responseGetAgreement> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agreement/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get ibow Staff Distribution
     * Get ibow Staff Distribution
     * @returns api_agreement_responseGetStaffDistribution responseGetStaffDistribution
     * @throws ApiError
     */
    public postAgreementGetDistribution({
        body,
    }: {
        /**
         * requestGetStaffDistribution
         */
        body: api_agreement_requestGetStaffDistribution,
    }): CancelablePromise<api_agreement_responseGetStaffDistribution> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agreement/get_distribution',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
